import * as THREE from "three";
import { servObj } from "./init_glob";
import {textureProgressLoader} from "./textureProgressLoader.js"
import {hideLoaderElement, showLoaderElement} from "./loaderElement.js"

import {addToCart} from "./cart.js"

const formatNumber = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

const scrollDuration = 300
let isInputsVis = false

const el = document.querySelector("#fence-count-price").parentNode
document.querySelector(".inputs-container").style.display = "none"

const fence = {
  type: "fence-cut",
  textureName: "stepnyak",
  rusTextureName: "Степняк"
}

servObj.fence = fence
servObj.defaultFence = {...fence}

// default
document.querySelector(`#option-block-pattern [value="${servObj.defaultFence.type}"]`).checked = true
document.querySelector(`#block-option-color [value="${servObj.defaultFence.textureName}"]`).checked = true
//document.querySelector(`[name="pier-height"]`).parentNode.classList.add("disabled")

const countFencePriceButton = document.querySelector(`#count-fence-price-button`)
countFencePriceButton.parentNode.classList.add("disabled")

const fenceWrapper = document.querySelector("#fence-spec-wrapper")

export const checkFenceInputs = () => {
    document.querySelector(`#option-block-pattern input[value="${servObj.fence.type}"]`).checked = true
    document.querySelector(`#block-option-color input[value="${servObj.fence.textureName}"]`).checked = true
}



// скролл
const smoothScrollTo = (element, target, duration) => {
  const start = element.scrollTop;
  const change = target - start;
  const startTime = performance.now();

  function animateScroll(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    element.scrollTop = start + change * progress;

    if (progress < 1) {
      requestAnimationFrame(animateScroll);
    }
  }

  requestAnimationFrame(animateScroll);
}

document.querySelector("#open-count-fence-price-button").addEventListener("pointerdown", () => {

  

  isInputsVis = !isInputsVis

  if(isInputsVis){
    document.querySelector(".inputs-container").style.display = "block"
    smoothScrollTo(el, el.scrollHeight - 500, scrollDuration );

    document.querySelector("#open-count-fence-price-button").classList.remove("full-rounded-button")
    document.querySelector("#open-count-fence-price-button").classList.add("not-full-rounded-button")

    document.querySelector("#open-count-fence-price-button").style.marginBottom = "0rem"
  }else{
    smoothScrollTo(el, 0, scrollDuration);
    setTimeout(() => {
      document.querySelector(".inputs-container").style.display = "none"
      document.querySelector("#open-count-fence-price-button").style.marginBottom = "100rem"
    }, scrollDuration)

    document.querySelector("#open-count-fence-price-button").classList.add("full-rounded-button")
    document.querySelector("#open-count-fence-price-button").classList.remove("not-full-rounded-button")

    
  }
})

const inputNames = ["fence-length", "fence-width", "gate-width", "wicket-width", "fence-height", "pier-height", "pillar-spacing"]

const isAllInputsHaveValue = () => {
  let bool = true
  inputNames.map(name => {
    const el = document.querySelector(`[name="${name}"]`)
    if(+el.value == 0 && !el.parentNode.classList.contains("disabled")) bool = false
  })

  return bool
}

inputNames.map(name => {

  document.querySelector(`[name="${name}"]`).addEventListener("change", e => {
    if(name == "fence-height") e.target.value = Math.round(e.target.value / 140) * 140
    if(name == "pier-height") e.target.value = Math.round(e.target.value / 140) * 140
    if(name == "pillar-spacing") e.target.value = Math.round(e.target.value / 390) * 390

    
  })
  //let lastValidValue = '1';
  document.querySelector(`[name="${name}"]`).addEventListener("input", e => {
    e.target.value = e.target.value.replace(/\D/g, "");

    //if(e.target.value == 0) e.target.value = ""

    if(isAllInputsHaveValue()){
      countFencePriceButton.parentNode.classList.remove("disabled")
    }else{
      countFencePriceButton.parentNode.classList.add("disabled")
    }
  })


  // if (/^\d*$/.test(this.value)) {
  //         //lastValidValue = formatNumber(Number(this.value))
  //         lastValidValue = this.value;
  //         //console.log(formatNumber(Number(this.value)))
  //         count.setCount(Number(this.value));
  //         calculatePrice();
  //     } else {
  //         this.value = lastValidValue;
  //     }

  //document.querySelector(`[name="${name}"]`).value = "6666"
})

const hideCounter = () => {
  if(document.querySelector("#fence-count-price").classList.contains("active")){
    const event = new Event('pointerdown')
    document.querySelector("#open-count-fence-price-button").dispatchEvent(event)
    fenceWrapper.style.display = "none"
    countFencePriceButton.parentNode.classList.add("disabled")
  }

  setTimeout(() => inputNames.map(name => document.querySelector(`[name="${name}"]`).value = ""), scrollDuration)
}

document.querySelector("#menu_selected-fence button").addEventListener("pointerdown", hideCounter)


// Выбор типа забора

export const applyFenceType = (type) => {

  const fenceFullInstanced = servObj.scene.getObjectByName("fence_brick_instanced")
  const fenceFull = servObj.scene.getObjectByName("fence_brick")
  const fenceCutInstanced = servObj.scene.getObjectByName("fence_half_brick_instanced")
  const fenceCut = servObj.scene.getObjectByName("fence_half_brick")

  fenceFullInstanced.traverse(_ => _.castShadow = true)
  fenceFull.traverse(_ => _.castShadow = true)
  fenceCutInstanced.traverse(_ => _.castShadow = true)
  fenceCut.traverse(_ => _.castShadow = true)

  if(type == "fence-full"){
    servObj.fence.type = type
    fenceFullInstanced.visible = true
    fenceFull.visible = true
    fenceCutInstanced.visible = false
    fenceCut.visible = false

    document.querySelector("#ann_wall").childNodes[0].style.display = "block"
    setTimeout(() => document.querySelector(`[name="pier-height"]`).parentNode.classList.add("disabled"), scrollDuration)
  }
  if(type == "fence-cut"){
    servObj.fence.type = type
    fenceFullInstanced.visible = false
    fenceFull.visible = false
    fenceCutInstanced.visible = true
    fenceCut.visible = true

    document.querySelector("#ann_wall").childNodes[0].style.display = "block"
    setTimeout(() => document.querySelector(`[name="pier-height"]`).parentNode.classList.remove("disabled"), scrollDuration)
  }
  if(type == "columns"){
    servObj.fence.type = type
    fenceFullInstanced.visible = false
    fenceFull.visible = false
    fenceCutInstanced.visible = false
    fenceCut.visible = false

    document.querySelector("#ann_wall").childNodes[0].style.display = "none"
    setTimeout(() => document.querySelector(`[name="pier-height"]`).parentNode.classList.add("disabled"), scrollDuration)
  }

  servObj.lightMain.shadow.needsUpdate = true

}

document.querySelector("#option-block-pattern").addEventListener("change", e => {
  hideCounter()
  applyFenceType(e.target.value)
})

export const applyFenceTexture = (textureName, rusTextureName, isShowLoader = true) => {

  hideCounter()

  servObj.fence.textureName = textureName
  servObj.fence.rusTextureName = rusTextureName

  const loaderManager = { }

  //showLoaderElement()

  const fenceFullInstanced = servObj.scene.getObjectByName("fence_brick_instanced")
  const fenceFull = servObj.scene.getObjectByName("fence_brick")
  const fenceCutInstanced = servObj.scene.getObjectByName("fence_half_brick_instanced")
  const fenceCut = servObj.scene.getObjectByName("fence_half_brick")

  const calculateTotalProgress = () => {
    let answer = 0

    for (let key in loaderManager){
      let total = loaderManager[key].total
      let loaded = loaderManager[key].loaded
      answer += loaded/total / 4
    }

    return answer
  }

  const calculateProgress = () => {
    let total = 1
    let loaded = 0
    let c = 0
    for (let key in loaderManager){
        total += loaderManager[key].total
        loaded += loaderManager[key].loaded
        if(loaderManager[key].total == loaderManager[key].loaded) c++
    }
    if(c == 4){ // IMPORTANT!! CANNOT USE "Object.keys(loaderManager).length"
      setTimeout(() => {
        if(isShowLoader) hideLoaderElement()
        if(isShowLoader) document.querySelector(".preloader_fon").style.width = `0%`
        if(isShowLoader) document.querySelector(".loader-procent").innerText = `0%`
        //cb && cb()
      }, 1000)
    }

    //if(isShowLoader) document.querySelector(".preloader_filled").style.backgroundPosition = `${(1 - calculateTotalProgress()) * 100}% 0`
    if(isShowLoader) document.querySelector(".preloader_fon").style.width = `${calculateTotalProgress() * 100}%`
  }

  if(isShowLoader) showLoaderElement()

  textureProgressLoader(`./textures/fence/${textureName}/${textureName}.webp` , map => {

    fenceFullInstanced.children[0].material.map = map
    fenceFull.children[0].material.map = map

    map.wrapS = THREE.RepeatWrapping
    map.wrapT = THREE.RepeatWrapping
    map.flipY = false
    map.colorSpace = THREE.SRGBColorSpace
    map.anisotropy = 16
    // map.offset = new THREE.Vector2(0, -0.4705899953842163)
    // map.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
  }, e => {
    loaderManager["map"] = {total: e.total, loaded: e.loaded}
    calculateProgress()
  })

  textureProgressLoader(`./textures/fence/${textureName}/${textureName}_pillar.webp` , map => {
    
    fenceFullInstanced.children[2].material.map = map
    fenceFull.children[2].material.map = map

    map.wrapS = THREE.RepeatWrapping
    map.wrapT = THREE.RepeatWrapping
    map.flipY = false
    map.colorSpace = THREE.SRGBColorSpace
    map.anisotropy = 16
    // map.offset = new THREE.Vector2(0, -0.4705899953842163)
    // map.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
  }, e => {
    loaderManager["map_pillar"] = {total: e.total, loaded: e.loaded}
    calculateProgress()
  })

  textureProgressLoader(`./textures/fence/n.webp`, normalMap => {

    fenceFullInstanced.children[0].material.normalMap = normalMap
    fenceFull.children[0].material.normalMap = normalMap

    normalMap.wrapS = THREE.RepeatWrapping
    normalMap.wrapT = THREE.RepeatWrapping
    normalMap.flipY = false
    normalMap.anisotropy = 16
    // normalMap.offset = new THREE.Vector2(0, -0.4705899953842163)
    // normalMap.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
  }, e => {
    loaderManager["n"] = {total: e.total, loaded: e.loaded}
    calculateProgress()
  })

  textureProgressLoader(`./textures/fence/n_pillar.webp`, normalMap => {

    fenceFullInstanced.children[2].material.normalMap = normalMap
    fenceFull.children[2].material.normalMap = normalMap

    normalMap.wrapS = THREE.RepeatWrapping
    normalMap.wrapT = THREE.RepeatWrapping
    normalMap.flipY = false
    normalMap.anisotropy = 16
    // normalMap.offset = new THREE.Vector2(0, -0.4705899953842163)
    // normalMap.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
  }, e => {
    loaderManager["n_pillar"] = {total: e.total, loaded: e.loaded}
    calculateProgress()
  })

  // cover-plate

  textureProgressLoader(`./textures/fence/cover-plate/${textureName}.webp` , map => {
    fenceFullInstanced.children[1].material.map = map
    fenceFull.children[1].material.map = map

    servObj.scene.getObjectByName("fence_half_brick_instanced").children[4].material.map = map
    
    map.needsUpdate = true

    // servObj.scene.getObjectByName("fence_half_brick_instanced").children[4].material = new THREE.MeshStandardMaterial({color: "#ff0000"})
    // servObj.scene.getObjectByName("fence_half_brick_instanced").children[4].material.map = map

    map.needsUpdate = true
    servObj.scene.getObjectByName("fence_half_brick_instanced").children[4].material.needsUpdate = true

    //map.channel = 1

    map.wrapS = THREE.RepeatWrapping
    map.wrapT = THREE.RepeatWrapping
    map.flipY = false
    map.colorSpace = THREE.SRGBColorSpace
    map.anisotropy = 16
    // map.offset = new THREE.Vector2(0, -0.4705899953842163)
    // map.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
  }, e => {
    // loaderManager["map"] = {total: e.total, loaded: e.loaded}
    // calculateProgress()
  })

  textureProgressLoader(`./textures/fence/cover-plate/n.webp`, normalMap => { // n.webp

    fenceFullInstanced.children[1].material.normalMap = normalMap
    fenceFull.children[1].material.normalMap = normalMap

    // fenceFull.children[1].material.normalMap.channel = 1
    // fenceFull.children[1].material.normalMap.needsUpdate = true;

    

    // const normalMap2 = new THREE.TextureLoader().load('./textures/fence/cover-plate/nn.jpg');
    // fenceFull.children[1].material.normalMap2 = normalMap2



    // fenceFull.children[1].material.onBeforeCompile = (shader) => {
    //         // Добавляем uniform для второй нормальной карты
    //         shader.uniforms.normalMap2 = { value: normalMap };
            
    //         // Добавляем атрибут для вторых UV
    //         shader.vertexShader = shader.vertexShader.replace(
    //             '#include <uv_pars_vertex>',
    //             `
    //             #include <uv_pars_vertex>
    //             #ifdef USE_UV2
    //                 varying vec2 vUv2;
    //             #endif
    //             `
    //         );
            
    //         shader.vertexShader = shader.vertexShader.replace(
    //             '#include <uv_vertex>',
    //             `
    //             #include <uv_vertex>
    //             #ifdef USE_UV2
    //                 vUv2 = uv1;
    //             #endif
    //             `
    //         );

    //         // Модифицируем фрагментный шейдер
    //         shader.fragmentShader = shader.fragmentShader.replace(
    //             '#include <normal_fragment_maps>',
    //             `
    //             #include <normal_fragment_maps>
                
    //             #ifdef USE_NORMALMAP2
    //                 vec3 normalTex2 = texture2D(normalMap2, vUv2).xyz * 2.0 - 1.0;
    //                 normal = normalize(normal + normalTex2);
    //             #endif
    //             `
    //         );
    //     };
    

    normalMap.wrapS = THREE.RepeatWrapping
    normalMap.wrapT = THREE.RepeatWrapping
    normalMap.flipY = false
    normalMap.anisotropy = 16
    normalMap.colorSpace = THREE.SRGBColorSpace

  }, e => {
    // loaderManager["n_pillar"] = {total: e.total, loaded: e.loaded}
    // calculateProgress()
  })
  textureProgressLoader(`./textures/fence/cover-plate/r.webp`, roughnessMap => {

    // fenceFullInstanced.children[1].material.roughnessMap = roughnessMap
    // fenceFull.children[1].material.roughnessMap = null

    // roughnessMap.wrapS = THREE.RepeatWrapping
    // roughnessMap.wrapT = THREE.RepeatWrapping
    // roughnessMap.flipY = false
    // roughnessMap.anisotropy = 16
  }, e => {
    // loaderManager["n_pillar"] = {total: e.total, loaded: e.loaded}
    // calculateProgress()
  })

}

document.querySelector("#block-option-color").addEventListener("change", e => {
  //console.log(e.target.parentNode.querySelector("p").innerText)
  applyFenceTexture(e.target.value, e.target.parentNode.querySelector("p").innerText, true)
})


// Рассчитать



// document.querySelector('[name="fence-height"]').addEventListener("change", e => {
//   e.target.value = Math.round(e.target.value / 140) * 140
// })
// document.querySelector('[name="pier-height"]').addEventListener("change", e => {
//   e.target.value = Math.round(e.target.value / 140) * 140
// })
// document.querySelector('[name="pillar-spacing"]').addEventListener("change", e => {
//   e.target.value = Math.round(e.target.value / 390) * 390
// })

let possibleAddToCard = []

const calculateFenceFrice = (columnBlockCount, fenceBlockCount, fenceFinishBlockCount, columnLidCount, fenceLidCount) => {
  let total = 0
  if(!window.fencePrice || !servObj.fence || !servObj.fence.textureName) return total

  possibleAddToCard = []

  window.fencePrice.map(el => {
    if(el.ID == "column_block" && el["Расцветка"] == servObj.fence.rusTextureName && columnBlockCount){
      possibleAddToCard.push({
        name: el["Наименование"] + ", " + el["Расцветка"], 
        price: el["Стоимость"] * columnBlockCount, 
        count: columnBlockCount, 
        imagePath: `./images/fence/${servObj.fence.textureName}/fence-column.png`
      })
      total += el["Стоимость"] * columnBlockCount
    }
    if(el.ID == "fence_block" && el["Расцветка"] == servObj.fence.rusTextureName && fenceBlockCount){
      possibleAddToCard.push({
        name: el["Наименование"] + ", " + el["Расцветка"], 
        price: el["Стоимость"] * fenceBlockCount, 
        count: fenceBlockCount, 
        imagePath: `./images/fence/${servObj.fence.textureName}/fence-block.png`
      })
      total += el["Стоимость"] * fenceBlockCount
    }
    if(el.ID == "fence_block_finishing" && el["Расцветка"] == servObj.fence.rusTextureName && fenceFinishBlockCount){
      possibleAddToCard.push({
        name: el["Наименование"] + ", " + el["Расцветка"], 
        price: el["Стоимость"] * fenceFinishBlockCount, 
        count: fenceFinishBlockCount, 
        imagePath: `./images/fence/${servObj.fence.textureName}/fence-block-finish.png`
      })
      total += el["Стоимость"] * fenceFinishBlockCount
    } 
    if(el.ID == "cover_plate" && el["Расцветка"] == servObj.fence.rusTextureName && fenceLidCount){
      possibleAddToCard.push({
        name: el["Наименование"] + ", " + el["Расцветка"], 
        price: el["Стоимость"] * fenceLidCount, 
        count: fenceLidCount, 
        imagePath: `./images/fence/${servObj.fence.textureName}/cover-plate.png`
      })
      total += el["Стоимость"] * fenceLidCount
    }
    if(el.ID == "cover_plate_wide" && el["Расцветка"] == servObj.fence.rusTextureName && columnLidCount){
      possibleAddToCard.push({
        name: el["Наименование"] + ", " + el["Расцветка"], 
        price: el["Стоимость"] * columnLidCount, 
        count: columnLidCount, 
        imagePath: `./images/fence/${servObj.fence.textureName}/cover-plate-wide.png`
      })
      total += el["Стоимость"] * columnLidCount
    }
  })

  //possibleAddToCard = []

  document.querySelector("#fence-price .price_count").innerText = formatNumber(total) + " руб.*"

}

countFencePriceButton.addEventListener("pointerdown", () => {

  const l = document.querySelector('[name="pillar-spacing"]')

  if(l.value < 390 / 2){
    document.querySelector("#count-fence-price-button").parentElement.classList.add("disabled")
    return;
  }

  fenceWrapper.style.display = "block"
  smoothScrollTo(el, el.scrollHeight - 400, scrollDuration)

  document.querySelector(`[name="fence-height"]`).value = Math.round(document.querySelector(`[name="fence-height"]`).value / 140) * 140
  document.querySelector(`[name="pier-height"]`).value = Math.round(document.querySelector(`[name="pier-height"]`).value / 140) * 140
  document.querySelector(`[name="pillar-spacing"]`).value = Math.round(document.querySelector(`[name="pillar-spacing"]`).value / 390) * 390


  const fenceLength = Number(document.querySelector('[name="fence-length"]').value)       // Длина участка
  const fenceWidth = Number(document.querySelector('[name="fence-width"]').value)         // Ширина участка
  const gateWidth = Number(document.querySelector('[name="gate-width"]').value)           // Ширина ворот
  const wicketWidth = Number(document.querySelector('[name="wicket-width"]').value)       // Ширина калитки
  const fenceHeight = Number(document.querySelector('[name="fence-height"]').value)       // Высота забора
  let pierHeight = Number(document.querySelector('[name="pier-height"]').value)           // Высота простенка
  const pillarSpacing = Number(document.querySelector('[name="pillar-spacing"]').value)   // Шаг столбов


  if(servObj.fence.type == "fence-full" || servObj.fence.type == "columns"){
    pierHeight = fenceHeight
  }

  const p = (fenceLength + fenceWidth) * 2 - gateWidth - wicketWidth
  const sectionCount = Math.ceil(p / pillarSpacing)

  const columnBlockCount = fenceHeight / 140 * sectionCount
  let fenceBlockCount = (pierHeight / 140) * (pillarSpacing / 390 - 1 - 1) * sectionCount
  let fenceFinishBlockCount = pierHeight / 140 * sectionCount
  const columnLidCount = sectionCount
  let fenceLidCount = (pillarSpacing / 390 - 1 - 1) * sectionCount // -финишный -столбовой блок

  if(servObj.fence.type == "columns" || fenceLidCount < 0){
    fenceBlockCount = 0
    fenceFinishBlockCount = 0
    fenceLidCount = 0
  }

  const namesFromPrice = {}

  window.fencePrice.map(el => {
    namesFromPrice[el["ID"]] = el["Наименование"]
  })

  //console.warn(namesFromPrice)

  document.querySelector("ol").innerHTML = `
    ${fenceFinishBlockCount && `<li class="fence-price">${namesFromPrice["fence_block"]}, ${servObj.fence.rusTextureName} <span style="white-space: nowrap;">- ${fenceBlockCount} шт.</span></li>`}
    ${fenceFinishBlockCount && `<li class="fence-price">${namesFromPrice["fence_block_finishing"]}, ${servObj.fence.rusTextureName} <span style="white-space: nowrap;">- ${fenceFinishBlockCount} шт.</span></li>`}
    <li class="fence-price">${namesFromPrice["column_block"]}, ${servObj.fence.rusTextureName} <span style="white-space: nowrap;">- ${columnBlockCount} шт.</span></li>
     
    
    <li class="fence-price">${namesFromPrice["cover_plate_wide"]} <span style="white-space: nowrap;">- ${columnLidCount} шт.</span></li>
    ${fenceLidCount && `<li class="fence-price">${namesFromPrice["cover_plate"]} <span style="white-space: nowrap;">- ${fenceLidCount} шт.</span></li>`}
  `

  calculateFenceFrice(columnBlockCount, fenceBlockCount, fenceFinishBlockCount, columnLidCount, fenceLidCount)

})

document.querySelector("#add_fence_to_cart").addEventListener("pointerdown", () => {
  //console.warn(possibleAddToCard)
  possibleAddToCard.map(c => {
    addToCart(c.name, c.price, c.count, c.imagePath)
  })
  //possibleAddToCard = []
  
})